import { Warehouses as NewWarehouses } from "./NewWarehouse";
import { DatatableContextProvider } from "@/components/tables/contexts/DatatableContextProvider";
import { useBreadcrumb } from "@/components/breadcrumbs";

const Warehouses = () => {
  useBreadcrumb("Warehouses");

  return (
    <DatatableContextProvider>
      <NewWarehouses />
    </DatatableContextProvider>
  );
};

export { Warehouses };
